import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function Modal({
  open,
  onClose,
  title,
  children
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-47">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-48">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-49">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-50">
              <h2 className="text-xl font-bold text-brand-charcoal font-heading" data-id="element-51">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-500" aria-label="Cerrar" data-id="element-52">
                <X className="w-5 h-5" data-id="element-53" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-sm text-gray-700 leading-relaxed space-y-4" data-id="element-54">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export const DisclaimerSection = () => {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-brand-charcoal text-gray-400 py-8 px-6 text-center text-xs md:text-sm" data-id="element-55">
        <div className="max-w-4xl mx-auto" data-id="element-56">
          <p data-id="element-57">
            Este producto tiene fines exclusivamente informativos y educativos.
            No sustituye el consejo médico profesional. Consulta con un
            especialista antes de iniciar cualquier protocolo, especialmente si
            tienes una condición médica.
          </p>

          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-58">
            <button onClick={() => setPrivacyOpen(true)} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-59">
              Política de Privacidad
            </button>
            <span className="opacity-30" data-id="element-60">|</span>
            <button onClick={() => setTermsOpen(true)} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-61">
              Términos y Condiciones
            </button>
          </div>

          <p className="mt-6 opacity-50" data-id="element-62">
            &copy; {new Date().getFullYear()} Hígado Vital. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Política de Privacidad */}
      <Modal open={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-63">
        <p data-id="element-64">
          <strong data-id="element-65">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-66">
          En Hígado Vital, nos comprometemos a proteger tu privacidad. Esta
          política describe cómo recopilamos, usamos y protegemos tu información
          personal.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-67">
          1. Información que recopilamos
        </h3>
        <p data-id="element-68">
          Recopilamos la información que nos proporcionas directamente al
          realizar una compra, como tu nombre, dirección de correo electrónico e
          información de pago. También podemos recopilar datos de uso del sitio
          web de forma automática.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-69">
          2. Uso de la información
        </h3>
        <p data-id="element-70">Utilizamos tu información para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-71">
          <li data-id="element-72">Procesar tu compra y entregarte el producto digital.</li>
          <li data-id="element-73">Enviarte comunicaciones relacionadas con tu compra.</li>
          <li data-id="element-74">Mejorar nuestros productos y servicios.</li>
          <li data-id="element-75">Cumplir con obligaciones legales.</li>
        </ul>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-76">
          3. Protección de datos
        </h3>
        <p data-id="element-77">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-78">
          4. Compartir información
        </h3>
        <p data-id="element-79">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cuando
          lo exija la ley.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-80">
          5. Tus derechos
        </h3>
        <p data-id="element-81">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal. Para ejercer estos derechos, contáctanos a través de nuestro
          correo electrónico de soporte.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-82">
          6. Cookies
        </h3>
        <p data-id="element-83">
          Nuestro sitio web puede utilizar cookies para mejorar tu experiencia
          de navegación. Puedes configurar tu navegador para rechazar cookies,
          aunque esto puede afectar la funcionalidad del sitio.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-84">
          7. Cambios a esta política
        </h3>
        <p data-id="element-85">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Te notificaremos sobre cambios significativos a través de
          nuestro sitio web o por correo electrónico.
        </p>
      </Modal>

      {/* Términos y Condiciones */}
      <Modal open={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-86">
        <p data-id="element-87">
          <strong data-id="element-88">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-89">
          Al acceder y utilizar este sitio web y adquirir el producto Hígado
          Vital, aceptas los siguientes términos y condiciones.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-90">
          1. Naturaleza del producto
        </h3>
        <p data-id="element-91">
          Hígado Vital es un producto digital de carácter informativo y
          educativo. No constituye asesoramiento médico, diagnóstico ni
          tratamiento. Siempre consulta con un profesional de la salud antes de
          iniciar cualquier protocolo.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-92">
          2. Uso del producto
        </h3>
        <p data-id="element-93">
          El producto es para uso personal y no comercial. Queda prohibida su
          reproducción, distribución o reventa sin autorización expresa.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-94">
          3. Política de reembolso
        </h3>
        <p data-id="element-95">
          Ofrecemos una garantía de satisfacción de 14 días. Si no estás
          satisfecha con el producto, puedes solicitar un reembolso completo
          dentro de los 14 días posteriores a la compra, sin preguntas.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-96">
          4. Resultados
        </h3>
        <p data-id="element-97">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que dependen de múltiples factores
          individuales como el estado de salud, la adherencia al protocolo y el
          estilo de vida.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-98">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-99">
          Todo el contenido de Hígado Vital, incluyendo textos, imágenes,
          diseños y metodologías, está protegido por derechos de autor. Queda
          prohibido su uso no autorizado.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-100">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-101">
          Hígado Vital no se hace responsable de daños directos o indirectos
          derivados del uso del producto. El usuario asume toda la
          responsabilidad por las decisiones tomadas con base en la información
          proporcionada.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-102">
          7. Modificaciones
        </h3>
        <p data-id="element-103">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios serán efectivos desde su publicación en el sitio
          web.
        </p>
        <h3 className="font-bold text-brand-charcoal text-base mt-2" data-id="element-104">
          8. Contacto
        </h3>
        <p data-id="element-105">
          Para cualquier consulta sobre estos términos, puedes contactarnos a
          través de nuestro correo electrónico de soporte.
        </p>
      </Modal>
    </>;
};